import { jsx as _jsx } from "react/jsx-runtime";
import { NodeStatusModalForm } from '../EntityModalForms/NodeStatusModalForm';
function EditNodeStatusModal({ isOpen, onClose, onUpdate, nodeStatus, isLoading }) {
    return (_jsx(NodeStatusModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onUpdate, isLoading: isLoading, mode: "edit", nodeStatus: nodeStatus, title: "Edit Node Status", submitIdleLabel: "Update", submitBusyLabel: "Updating...", bindingSelectId: "binding" }));
}
export default EditNodeStatusModal;
